// @ts-nocheck
import React from 'react'

const TextBlock = ({ id, placeholder, label, formId }) => {

  return (
    <>
      <div className="mb-6">
      <label data-i18n-ignore="true" className="mb-2 block text-sm font-semibold text-slate-800">{label}</label>
        <div data-i18n-ignore="true" className="w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm leading-6 text-slate-600">
          {placeholder}
        </div>
      </div>
    </>

  );
};

export default TextBlock;




